export const offlineServiceConfigurations = {
    user: { readOnly: true, activateSoftDelete: true },
    role: { readOnly: true, activateSoftDelete: true },
    alert: { readOnly: true },
    'book-configuration': { readOnly: true },
    protocolType: { readOnly: true, activateSoftDelete: true },
    protocolContentType: { readOnly: true, activateSoftDelete: true },
    protocolTypeGroup: { readOnly: true },
    book: { readOnly: true, activateSoftDelete: true },
    file: { readOnly: true },
    equipmentList: { readOnly: true, activateSoftDelete: true },
    plausibilityCheck: { readOnly: true, activateSoftDelete: true },
    view: { readOnly: true },
    'book-arrangement': { readOnly: true },
    'etmal-calculation': { readOnly: true, activateSoftDelete: true },
    protocol: {},
    protocolDraft: {},
    approval: {},
    'noon-report-dispatch': {},
    equipmentItem: {},
    'error-log': {},
    vessel: {},
    crewList: {},
    voyage: {},
    'record-file': { readOnly: true },
    order: { readOnly: true, activateSoftDelete: true },
    'sounding-spot': { activateSoftDelete: true },
    responsibility: { readOnly: true, activateSoftDelete: true },
    checklistType: { readOnly: true, activateSoftDelete: true },
    'book-key-bundle': {},
    systemInfo: { readOnly: true },
};
//# sourceMappingURL=OfflineServiceConfigurations.js.map